import React from 'react';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../_common/constants/pathnames';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const CustomerDetailsLink = () => {

  return (
    <AsideMenuLink
      pathname={P.CUSTOMER_DETAILS}
      icon={'Folder_pink.svg'}
      isSubSection={true}
      label={<FormattedMessage id="customer-details-page-link" defaultMessage="Customer details"/>}
    />
  );
};

export default CustomerDetailsLink;
